module.exports = __webpack_public_path__ + "img/search_icon.9f5649c2.png";